// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as SendComponent} from './Send.svg';

import Icon, { TIconProps } from '../Icon';

export const IconSend = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <SendComponent/>
  </Icon>
));
